module.exports = __webpack_public_path__ + "static/media/subuka.b4cbfc19.png";